import { SearchConfig, FETCH_METHODS } from "../api.model";
import { BUTTON_NAMES } from "../common.model";
import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from "../dynamic-data-table.model";
import { FieldNames, AdjustedTenureNumber, Attachment, BrandDropdown, commentsText, DealerDropdown, DefaultDropdown, SpinIdNumber, ActualTenureNumber, defaultSearchContainerButtons } from "../form-fields.model";
import { FormFieldConfig, ButtonFieldConfig, DynamicFormArray, Props, DisplayTranformation } from "../form.model";
import { LucideRefreshCcw } from '@lucide/angular';

export const updatedUserName = 'updatedUserName'

export const AdjustedTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getTenureHistoryOverall",
  body: {
    page: '',
    pageSize: ''
  }
}

const FormFieldArray: FormFieldConfig[] = [
  {
    ...structuredClone(SpinIdNumber), required: true
  }
];

const AdditionalFormsArray: FormFieldConfig[] = [
  {
    ...structuredClone(DefaultDropdown), fieldName: FieldNames.Type, displayName: 'Tenure Type', required: true, displayTranformation: DisplayTranformation.none, disabled: true, showSelect: false, defaultValue: 'brand', selectedValue: 'brand',
    options: [{ fieldLabel: 'Brand', fieldValue: 'brand' }, { fieldLabel: 'Dealer', fieldValue: 'dealer' }, { fieldLabel: 'Job', fieldValue: 'job' }, { fieldLabel: 'OEM', fieldValue: 'oem' }]
  },
  { ...structuredClone(BrandDropdown), required: true, disabled: true },
  { ...structuredClone(DealerDropdown), fieldName: FieldNames['DealerCode'], displayName: 'Dealer', options: [], displayTranformation: DisplayTranformation.none, required: true, isLoading: true, disabled: true },
  { ...structuredClone(DefaultDropdown), fieldName: FieldNames.JobCode, displayName: 'Job', disabled: true, required: true },
  { ...structuredClone(ActualTenureNumber), disabled: true },
  { ...structuredClone(AdjustedTenureNumber), disabled: true },
  { ...structuredClone(commentsText), required: true, disabled: true },
  { ...structuredClone(Attachment), multiple: true, disabled: true, }
];

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);
const AdditionalFormButtonArray: ButtonFieldConfig[] = [
  { isDisabled: false, name: BUTTON_NAMES.Adjust, isPrimary: true },
  { isDisabled: false, name: BUTTON_NAMES.Reset }
];


export const TenureAdjustmentTitle = "Search";
export const TenureAdjustmentResetActionName = 'Reset';
export const AdjustmentTenureCreationTitle = "Update Tenure"
export const AdjustedTenureFilterForm = 'Adjustment Tenure Filter Form';
export const AdjustedTenureUpdateForm = 'Adjustment Tenure Update Form';
export const AdjustmentTenureTableTitle = 'Tenure Adjustment History'

export const TenureAdjustmentFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  AdditionalForms: {
    isEnabled: false,
    FieldsArray: AdditionalFormsArray,
    ButtonsArray: AdditionalFormButtonArray,
    formName: AdjustedTenureUpdateForm,
    title: AdjustmentTenureCreationTitle,
    props: {
      optionExplanation: [
        'Tenure displayed in Months'
      ]
    }
  },
  formName: AdjustedTenureFilterForm,
  ButtonsArray: FormButtonArray,
  searchConfig: AdjustedTenureSearchConfig,
  title: TenureAdjustmentTitle,
  resetAfterSubmit: true
}

const columnSchema: Array<TableColumnSchema> = [
  { label: "SPIN ID", fieldKey: FieldNames['SpinId'] },
  { label: "BRAND", fieldKey: FieldNames['Brand'] },
  { label: "DEALER", fieldKey: 'organizationCode' },
  { label: "JOB", fieldKey: 'jobCode' },
  { label: "TENURE TYPE", fieldKey: 'tenureType', isNotCamelCase: true },
  { label: "Actual Tenure", fieldKey: FieldNames['ActualTenure'] },
  { label: "Adjusted Tenure", fieldKey: FieldNames['AdjustedTenure'], isCamelCaseHeader: true },
  { label: "Total Tenure", fieldKey: 'totalTenure', isCamelCaseHeader: true },
  { label: "Comments", fieldKey: FieldNames['Comments'], isCamelCaseHeader: true },
  { label: "Adjusted On", fieldKey: 'createdOn', isCamelCaseHeader: true },
  { label: "Adjusted By", fieldKey: FieldNames['CreatedBy'], isCamelCaseHeader: true },
  {
    label: 'Attachments', fieldKey: 'tenureAttachments', fieldType: 'Actions', actionConfig: [
      {
        fieldKey: FieldNames['Attachment'],
        hasBadge: true,
        badgeField: 'attachmentCount',
        iconClass: 'fa-solid fa-paperclip',
        toolTip: 'Click to view the attachments'
      }
    ]
  }
]

export const TenureAdjustmentTableSchema: DataTableSchema = {
  ...structuredClone(DefaultTableSchema),
  columnSchema: columnSchema,
  tableTitle: AdjustmentTenureTableTitle,
  headerActions: [{
    fieldKey: TenureAdjustmentResetActionName,
    actionLabel: 'Refresh',
    iconClass: LucideRefreshCcw,
    toolTip: 'Refresh',
    actionName: "Refresh"
  }],
  serverSidePaginatation: true,
  exportConfig: {
    fileName: 'Tenure_Adjustment',
    isCamelCase: [FieldNames['SpinId'], FieldNames['Brand'], 'organizationCode', FieldNames['JobCode'],
    FieldNames['ActualTenure'], FieldNames['AdjustedTenure'], 'totalTenure',
    FieldNames['Comments'], 'createdOn', FieldNames['CreatedBy'], FieldNames['Attachment'],],
    dateFields: ['createdOn'],
    attachmentFields: [FieldNames['Attachment']],
    schema: {
      [FieldNames['SpinId']]: "Spin ID",
      [FieldNames['Brand']]: "Brand",
      organizationCode: "Dealer",
      [FieldNames['JobCode']]: "Job",
      tenureType: "Tenure Type",
      [FieldNames['ActualTenure']]: "Actual Tenure",
      [FieldNames['AdjustedTenure']]: "Adjusted Tenure",
      totalTenure: "Total Tenure",
      [FieldNames['Comments']]: "Comments",
      createdOn: "Adjusted On",
      [FieldNames['CreatedBy']]: "Adjusted By",
      [FieldNames['Attachment']]: "Attachments"

    },
    exportMessage: 'Tenure Adjustment Data'
  },
  isSearchRequired: true,
  isPaginationRequired: true
}

export const TenureAdjustmentProps: Props = {}

export const validateSpinSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "spinIdCheck",
  body: {
    spinId: ''
  }
}

export const AdjustmentTenureUpdateSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "updateTenure",
  body: {
    "spinId": "",
    "adjustedTenure": "",
    "updatedBy": "",
    "updatedByName": '',
    "comments": "",
    "isOem": true,
    "type": "brand"
  }
}


export const AdjustmentAttchmentSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "tenureUpload",
  body: {
    [FieldNames['Attachment']]: '',
    [FieldNames['SpinId']]: '',
    type: 'brand',
    tenureId: ''
  },
  headers: {}
}






